import React, { useEffect } from 'react'
import Footer from './Footer'
import FAQSection from './FAQSection'
import DemoForm from './DemoForm'
import Navbar from './Navbar'
import { useLocation } from 'react-router-dom'

const AboutUsPage = () => {
    const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo({
                top: 0,
                left: 0,
            });
        }, [pathname]);
    return (
        <div className="text-gray-900" data-page="about">
            <main>
                <div className='bg-[#222129] lg:bg-opacity-60 z-10 sticky lg:static top-0 px-6'>
                    <Navbar />
                </div>
                <section className="pt-24">
                    <div className="max-w-6xl mx-auto">
                        <div className=" text-center max-w-4xl mx-auto px-4">
                            <h1 className="text-4xl md:text-4xl font-semibold leading-snug ">
                                Empowering <span className="text-[#FD6600] ">Construction Teams </span>
                                With Smart Procurement
                            </h1>
                            <p className="mt-4 md:mt-8 lg:text-lg text-xl text-gray-600">
                                {/* Neevay automates Quotation Comparison, simplifies Vendor Management,saving time and money bringing Transparency, Speed and Cost Control to the companies */}
                                Neevay automates RFQs, vendors, and orders, saving time and boosting clarity.
                            </p>
                        </div>

                        <div className="mt-12 flex justify-center rounded-md w-2/3 mx-auto lg:shadow-lg lg:bg-[#FDEFE4]">
                            <img src="https://neevaywebapp.blob.core.windows.net/website/about_us.png" alt="Neevay team illustration"
                                className="max-w-3xl h-[300px] object-cover" />
                        </div>
                    </div>
                </section>

                {/* why choose neevay */}
                <section className="bg-[#1f1f23] text-white py-16">
                    <div className="max-w-5xl mx-auto px-6 text-center space-y-6">
                        <button
                            className="px-6 py-2 text-base rounded-full bg-[#2E1F1A] text-[#FF6A00] border border-[#FF6A00] font-medium tracking-wide">
                            Why Choose Neevay
                        </button>
                        <h2 className="text-3xl font-semibold">Built for Construction Procurement</h2>
                        <p className="text-gray-300 max-w-3xl mx-auto">
                            Neevay isn’t generic software — it’s purpose-built for the pace, complexity, and realities of
                            construction teams. From trade-specific RFQs to compliant orders, everything is designed to
                            streamline how you actually work on-site and in-office.
                        </p>

                        <div className="md:flex justify-between items-center mt-10 gap-6">
                            <div className="py-6 px-4 rounded-2xl text-center">
                                <p className="text-2xl font-semibold text-[#FD6600]">200+</p>
                                <p className="text-sm text-gray-300 mt-1">Projects</p>
                            </div>
                            <div className="bg-white/20 w-[1px] self-stretch"></div>

                            <div className="py-6 px-4 rounded-2xl text-center">
                                <p className="text-2xl font-semibold text-[#FD6600]">15,000+</p>
                                <p className="text-sm text-gray-300 mt-1">RFQ's Processed</p>
                            </div>
                            <div className="bg-white/20 w-[1px] self-stretch"></div>

                            <div className="py-6 px-4 rounded-2xl text-center">
                                <p className="text-2xl font-semibold text-[#FD6600]">₹896 Cr+</p>
                                <p className="text-sm text-gray-300 mt-1">RFQ's Managed</p>
                            </div>
                            <div className="bg-white/20 w-[1px] self-stretch"></div>

                            <div className="py-6 px-4 rounded-2xl text-center">
                                <p className="text-2xl font-semibold text-[#FD6600]">18,000+</p>
                                <p className="text-sm text-gray-300 mt-1">Verified Vendors</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* our mission our journey */}
                <section className="bg-white gap-y-16 mx-auto ">
                    <div className=" md:p-16 p-8 grid md:grid-cols-3 gap-x-12 lg:gap-y-12 gap-y-4 items-start">

                        <h2 className="text-4xl text-center font-semibold">Our Mission
                        </h2>
                        <div className="col-span-2">
                            <p className="text-gray-600 text-base">
                                To digitize and simplify procurement workflows for every construction team in India. We believe
                                faster procurement means faster projects — and fewer manual errors mean stronger margins.
                            </p>
                        </div>
                    </div>
                    <div className="bg-[#F4F5FA80] md:p-16 p-8 grid md:grid-cols-3 gap-x-12 lg:gap-y-12 gap-y-4 items-start">
                        <h2 className="text-4xl lg:text-center font-semibold">Our Journey
                        </h2>
                        {/* <div className=""> */}
                            <div className="text-base space-y-4 text-gray-700">
                                <div>
                                    <p className="journey-title font-semibold">
                                        Identified the Real Pain
                                    </p>
                                    <p className="text-gray-600">
                                        Procurement teams were buried in email threads, Excel sheets, and vendor confusion —
                                        wasting hours every day with no visibility or control.
                                    </p>
                                </div>
                                <div>
                                    <p className="journey-title font-semibold">
                                        Co-Created with the Industry
                                    </p>
                                    <p className="text-gray-600">
                                        We partnered with leading construction companies to design Neevay around real-world
                                        workflows, not assumptions — shaping every module with on-ground insights.
                                    </p>
                                </div>
                                <div>
                                    <p className="journey-title font-semibold">
                                        Scaling into the Future
                                    </p>
                                    <p className="text-gray-600">
                                        Today, Neevay handles everything from vendor discovery to billing — building toward
                                        a
                                        connected, intelligent operating system for construction procurement.
                                    </p>
                                </div>
                            </div>
                        {/* </div> */}
                    </div>
                </section>
                {/* What Makes Neevay Different */}
                <section className="pt-12 pb-16 px-8">
                    <h2 className="text-3xl text-center font-semibold">What Makes Neevay Different</h2>
                    <div className="mt-10 grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
                        <div className="p-6 border rounded-2xl">
                            <img className="h-8" src="https://neevaywebapp.blob.core.windows.net/website/icon_7.png" alt="" />
                            <h4 className="font-semibold mt-4">Tailored for Construction Teams</h4>
                            <p className="text-sm mt-2">Not a generic ERP — Neevay is tailored for RFQs, vendors, and workflows
                                unique to construction teams.</p>
                        </div>
                        <div className="p-6 border rounded-2xl">
                            <img className="h-8" src="https://neevaywebapp.blob.core.windows.net/website/icon_8.png" alt="" />
                            <h4 className="font-semibold mt-4">End-to-End Procurement</h4>
                            <p className="text-sm mt-2">Manage everything from vendor discovery to billing in one platform — no
                                spreadsheets or silos.</p>
                        </div>
                        <div className="p-6 border rounded-2xl">
                            <img className="h-8" src="https://neevaywebapp.blob.core.windows.net/website/icon_9.png" alt="" />
                            <h4 className="font-semibold mt-4">Smarter RFQs, Faster Decisions</h4>
                            <p className="text-sm mt-2">Send ranked, transparent RFQs with live vendor tracking — reducing
                                turnaround time and improving quote quality.</p>
                        </div>
                    </div>
                </section>
                {/* For Construction companies */}
                <section className="bg-[#F9FAFC] py-16">
                    <div className="max-w-6xl mx-auto px-6">
                        <div className="grid md:grid-cols-2 lg:gap-10 gap-4 items-start">
                            <div>
                                <h2 className="text-3xl md:text-4xl font-semibold leading-snug">
                                    For Construction<br className="hidden md:block" /> Companies
                                </h2>
                            </div>
                            <div>
                                <p className="text-gray-600 text-base">
                                    Speed up procurement, eliminate manual processes, and gain complete control over your RFQs
                                    - all from a platform built specifically for the construction industry.
                                </p>
                            </div>
                        </div>

                        <div className="mt-10 grid gap-6 md:grid-cols-3">
                            <div className="relative bg-white rounded-2xl p-6">
                                <span className="absolute left-0 top-6 h-20 rounded-l w-1 bg-[#FD660033] rounded-full"></span>
                                <h3 className="text-2xl">🕒</h3>
                                <h3 className="font-semibold text-base md:text-lg">Save 3-4 Hours Every Day</h3>
                                <p className="mt-3 text-sm text-gray-600">
                                    Automate quote collection, comparison, and vendor coordination - no more chasing
                                    follow-ups over WhatsApp and Excel.
                                </p>
                            </div>
                            <div className="relative bg-white rounded-2xl p-6">
                                <span className="absolute left-0 top-6 h-20 rounded-l w-1 bg-[#FD660033] rounded-full"></span>
                                <h3 className="text-2xl">💸</h3>
                                <h3 className="font-semibold text-base md:text-lg">Save Costs by Up to 15% per order</h3>
                                <p className="mt-3 text-sm text-gray-600">
                                    Drive vendor competition and use side-by-side quote comparisons to secure the best value on
                                    every order.
                                </p>
                            </div>
                            <div className="relative bg-white rounded-2xl p-6">
                                <span className="absolute left-0 top-6 h-20 rounded-l w-1 bg-[#FD660033] rounded-full"></span>
                                <h3 className="text-2xl">📈</h3>
                                <h3 className="font-semibold text-base md:text-lg">Track Everything in Real-Time</h3>
                                <p className="mt-3 text-sm text-gray-600">
                                    Stay on top of procurement with live dashboards, quote status tracking, and instant savings
                                    visibility.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {/* for vendors & suppliers */}
                <section className="py-16">
                    <div className="max-w-6xl mx-auto px-6">
                        <div className="grid md:grid-cols-2 lg:gap-10 gap-4 items-start">
                            <div>
                                <h2 className="text-3xl md:text-4xl font-semibold leading-snug">
                                    For Vendors<br className="hidden md:block" /> & Suppliers
                                </h2>
                            </div>
                            <div>
                                <p className="text-gray-600 text-base md:text-lg">
                                    Get matched with live RFQs from real builders, quote in minutes, and grow your business —
                                    all without chasing follow-ups or paperwork.
                                </p>
                            </div>
                        </div>

                        <div className="mt-10 grid gap-6 md:grid-cols-3">
                            <div className="relative bg-white border rounded-2xl p-6">
                                <span className="absolute left-0 top-6 h-20 rounded-l w-1 bg-[#FD660033] rounded-full"></span>
                                <h3 className="text-2xl">📥</h3>
                                <h3 className="font-semibold text-base md:text-lg">Receive Verified RFQs Instantly</h3>
                                <p className="mt-3 text-sm text-gray-600">
                                    Get direct access to real-time RFQs from vetted builders in your categories — no middlemen,
                                    no cold calls.
                                </p>
                            </div>
                            <div className="relative bg-white border rounded-2xl p-6">
                                <span className="absolute left-0 top-6 h-20 rounded-l w-1 bg-[#FD660033] rounded-full"></span>
                                <h3 className="text-2xl">✍️</h3>
                                <h3 className="font-semibold text-base md:text-lg">Submit Quotes in Minutes</h3>
                                <p className="mt-3 text-sm text-gray-600">
                                    Use a simple digital interface to respond to RFQs quickly and professionally — no Excel
                                    sheets, no email chains.
                                </p>
                            </div>
                            <div className="relative bg-white border rounded-2xl p-6">
                                <span className="absolute left-0 top-6 h-20 rounded-l w-1 bg-[#FD660033] rounded-full"></span>
                                <h3 className="text-2xl">📬</h3>
                                <h3 className="font-semibold text-base md:text-lg">Track Quotes & Get Feedback</h3>
                                <p className="mt-3 text-sm text-gray-600">
                                    See when your quote is viewed, compare your pricing anonymously, and learn how to improve
                                    win rates.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <FAQSection />
                <DemoForm />
                <Footer />
            </main>

            <script src="Script.js"></script>
        </div>
    )
}

export default AboutUsPage